import axios from "axios";

interface IAssetListParams {
  pageNo?: number;
  pageSize?: number;
}

export const getVehicleList = (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IAssetListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/gatereader/v3/vehicle", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const addVehicle = (
  vehiclePlate: string,
  vehicleCode: string,
  fleetName: string,
  sensorSerialNumber: string
) => {
  return axios
    .post("/gatereader/v3/vehicle",
      {
        "VehiclePlate": vehiclePlate,
        "VehicleCode": vehicleCode,
        "FleetName": fleetName,
        "SensorSerialNumber": sensorSerialNumber
      },

    )
    .then((response) => {

      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const updateVehicle = (
  vehicleId: string,
  vehiclePlate: string,
  vehicleCode: string,
  fleetName: string
) => {

  return axios
    .put("/gatereader/v3/vehicle/" + vehicleId,
      {
        "VehiclePlate": vehiclePlate,
        "VehicleCode": vehicleCode,
        "FleetName": fleetName
      },

    )
    .then((response) => {

      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const unlinkSensor = (vehicleId: string) => {
  return axios
    .post("/gatereader/v3/vehicle/" + vehicleId + "/UnlinkSensor"
    )
    .then((response) => {

      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const linkSensor = (vehicleId: string, sensorSerialNumber: string) => {
  return axios
    .post("/gatereader/v3/vehicle/" + vehicleId + "/linkSensor",
      {
        "SensorSerialNumber": sensorSerialNumber
      }
    )
    .then((response) => {

      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};